<template>
  <Modal ref="modal" :grande="grande">
    <template v-slot:cabecera>
      <h5 class="modal-title">
        <slot name="titulo"></slot>
      </h5>
      <!-- Acciones -->
      <div class="btn-group" role="group">
        <div v-show="!Agregando && $refs.acciones.childElementCount" class="dropdown">
          <button class="btn btn-secondary dropdown-toggle" type="button" id="dropdownAcciones"
            data-bs-toggle="dropdown" aria-expanded="false">
            Acciones
          </button>
          <ul ref="acciones" class="dropdown-menu" aria-labelledby="dropdownAcciones">
            <li v-if="PermiteEliminar">
              <button @click="clickEliminar()" class="dropdown-item" type="button">
                Eliminar
              </button>
            </li>
            <!-- Acciones extra -->
            <!-- Aquí se pondrá el contenido cuya clase sea "accion"-->
            <slot name="accion"></slot>
          </ul>
        </div>
      </div>
    </template>
    <template v-slot:cuerpo>
      <Formulario ref="formulario">
        <!-- Aquí se pondrá el contenido que no se muestra en los slots -->
        <slot :item="item"></slot>
        <!-- Footer -->
        <div class="modal-footer mt-2">
          <button @click="clickCancelar()" type="button" class="btn btn-secondary">
            Cancelar
          </button>
          <button @click="clickGuardar()" type="button" class="btn btn-primary">
            Guardar
          </button>
        </div>
      </Formulario>
    </template>

  </Modal>
</template>
<script>
import Swal from "sweetalert2";

import Formulario from "../formularios/Formulario.vue";
import Modal from "./Modal";
import { Util } from "../../../util";


const EVENTO_ELIMINAR = "evento-eliminar";
const EVENTO_GUARDAR = "evento-guardar";
const SAVING_ERROR_EVENT = "on-saving-error";

export default {
  components: {
    Formulario,
    Modal
  },
  props: {
    facade: Function,
    /** Si se quiere un modal grande */
    grande: Boolean,
    /** Indica si se permite eliminar una entidad */
    permiteEliminar: {
      type: Boolean,
      default: true
    },
  },
  data() {
    return {
      item: {},
      /** Cuando se está guardando o eliminando */
      trabajando: false
    };
  },
  computed: {
    Agregando() {
      // Se está agregando cuando no se tiene un id
      return !this.item.id;
    },
    PermiteEliminar() {
      return this.permiteEliminar;
    },
    Trabajando() {
      return this.trabajando;
    }
  },
  methods: {
    /**
     * Limpia los datos anteriores y abre el modal
     * @param item item editado, si no se pasa un item, se abre en modo creación
     */
    abrir(item = null) {
      if (item)
        // Se realiza una copia profunda para que no queden enlazados con el item original al cambiar campos en el item editado
        this.item = Util.copiaProfunda(item);
      // Trabajar con un item limpio
      else this.item = {}, this.item.activo = true;

      this.$refs.formulario.limpiarFeedback();

      this.$refs.modal.abrir();
    },
    clickCancelar() {
      this.$refs.modal.cerrar();
    },
    clickEliminar() {
      // Solo se puede eliminar items con id (esta comprobacion se agregó para que no salte un error de compilación)
      if (this.item.id) {
        this.trabajando = true;

        Swal.fire({
          title: "¿Estás seguro?",
          icon: "question",
          showCancelButton: true,
          showLoaderOnConfirm: true,
          confirmButtonColor: "#d33",
          cancelButtonColor: "rgb(125 133 140)",
          confirmButtonText: "Si, eliminar",
          cancelButtonText: "Cancelar",
          // Para que no se cierre el modal al apretar Escape
          keydownListenerCapture: true,
          preConfirm: () => {
            return this.facade
              .deleteById(this.item.id)
              .then(() => {
                this.eliminado(this.item);
              })
              .catch(() => {
                Swal.showValidationMessage("Ocurrió un error al eliminar");
              });
          }
        })
          .then(result => {
            // Si confirma
            if (result.isConfirmed) {
              Swal.fire("Confirmación", "Eliminado correctamente", "success");
            }
          })
          .catch(error => this.savingError(error))
          .finally(() => (this.trabajando = false));
      }
    },
    // Este método se utiliza al crear y al editar
    clickGuardar() {

      if (this.$refs.formulario.esValido()) {
        this.trabajando = true;

        // Si el item tiene id es porque se está editando
        if (this.item.id) {
          this.facade
            .update(this.item)
            .then(() => {
              this.$emit(EVENTO_GUARDAR, this.item);
              this.$refs.modal.cerrar();
            })
            .catch(error => {
              this.savingError(error);
              this.trabajando = false;
            });
        }
        // Se está creando
        else {
          this.facade
            .create(this.item)
            .then(response => this.guardado(response.data))
            .catch(error => this.savingError(error))
            .finally(() => (this.trabajando = false));
        }
      } else {
        this.$refs.formulario.mostrarFeedback();
      }
    },
    /** Mostrar modal sin aplicar lógica extra */
    mostrarSinLimpiar() {
      this.$refs.modal.abrir();
    },
    /** Ocultar modal sin aplicar lógica extra */
    ocultarSinLimpiar() {
      this.$refs.modal.cerrar();
    },

    // ---- Métodos privados ----
    eliminado() {
      this.$emit(EVENTO_ELIMINAR, this.item);

      this.$refs.modal.cerrar();
    },
    savingError(error) {
      this.$emit(SAVING_ERROR_EVENT, error);
    },
    /**
     * Cuando un item es guardado en el servidor
     * @param itemEnServidor item que se guardó en el servidor (datos rellenados por el servidor)
     */
    guardado(itemEnServidor) {
      // Emitir evento con el item guardado
      this.$emit(EVENTO_GUARDAR, itemEnServidor);

      this.$refs.modal.cerrar();
    }
  }
};
</script>
